
























































































































import moment from 'moment';
import Vue from 'vue';
import { Route } from 'vue-router';
import PoseIcon from '@/components/PoseIcon.vue';

const audio: HTMLAudioElement = new Audio();
const builtin = require('@/data/builtin.json');
const difficulty = require('@/data/difficulty.json');
const posesMap = require('@/data/poses.json');

interface DefinitionNode {
  [key: string]: any;
}

interface PrintLayoutItem {
  [key: string]: any;
}

interface SessionItem {
  [key: string]: any;
}

interface Song {
  builtin?: number;
  album?: string;
  artist?: string;
  image?: string;
  isrc?: string;
  preview?: string;
  song?: string;
  type: string;
}

interface PrintLayoutBuildParams {
  breathDuration?: number;
  firstOccurrence: boolean;
  itemIndexToPrintItemDictionary: any;
  loopIterationDepth: number;
  nodeToItemIndexDictionary: any;
  printLayoutItems: PrintLayoutItem[];
  sessionItems: SessionItem[];
}

interface StateUpdate {
  lastMusicNode: DefinitionNode | null;
  lastTempoNode: DefinitionNode | null;
  params: PrintLayoutBuildParams;
  firstActionNode: number | null;
}

export default Vue.extend({
  name: 'Practice',
  components: {
    PoseIcon,
  },
  data() {
    return {
      builtin,
      loaded: false,
      playing: undefined as number | undefined,
      practiceId: String,
      practiceInfo: {},
      printLayout: [] as PrintLayoutItem[],
      songs: [] as Song[],
    };
  },
  created() {
    this.identifyPractice();
  },
  beforeDestroy() {
    audio.pause();
    audio.removeAttribute('src');
  },
  methods: {
    createSessionLayoutRecursiveWithParams(nodes: [any]): any {
      let lastTempoNode: DefinitionNode | null = null;
      let lastMusicNode: DefinitionNode | null = null;
      let firstActionNode: number | null = null;

      let params: PrintLayoutBuildParams = {
        breathDuration: undefined,
        firstOccurrence: true,
        itemIndexToPrintItemDictionary: {},
        loopIterationDepth: 0,
        nodeToItemIndexDictionary: {},
        printLayoutItems: [],
        sessionItems: [],
      };

      for (let i = 0; i < nodes.length; i += 1) {
        const stateUpdate = this.createSessionPrintLayoutWithDuration(
          nodes[i], params, firstActionNode, lastTempoNode, lastMusicNode, i,
        );

        ({ lastTempoNode, lastMusicNode, params, firstActionNode } = stateUpdate);
      }

      let currentLoopDepth = 0;
      const currentLoopRepeat = [-1, -1];
      const currentLoopStartItem = [-1, -1];
      let currentSongStack = [];
      let currentTempo = 0;
      let currentTime = 0;
      let firstNode = true;
      let nextSongTime = 0;

      for (let i = 0; i < params.printLayoutItems.length; i += 1) {
        if (params.printLayoutItems[i].section) {
          continue;
        }

        // Update current practice tempo, if tempo present
        if (Object.prototype.hasOwnProperty.call(params.printLayoutItems[i], 'tempo')) {
          currentTempo = parseFloat(params.printLayoutItems[i].tempo);
        }

        // Duration for this position
        let duration = 0;

        if (params.printLayoutItems[i].holdDuration > 0) {
          duration = currentTempo + (params.printLayoutItems[i].holdDuration * currentTempo);
        } else {
          duration = currentTempo + (params.printLayoutItems[i].holdDuration * -1);
        }

        // Progress current time in practice
        currentTime += duration;

        // Define empty endsAt array if it doesn't exist on layout item
        /* if (!Object.prototype.hasOwnProperty.call(params.printLayoutItems[i], 'endsAt')) {
          params.printLayoutItems[i].endsAt = [];
        } */

        // Push current time to layout item's endsAt array
        // params.printLayoutItems[i].endsAt.push(currentTime);

        // Define empty music array if it doesn't exist on layout item
        if (!Object.prototype.hasOwnProperty.call(params.printLayoutItems[i], 'music')) {
          params.printLayoutItems[i].music = [];
        }

        // Music node checks
        if (Object.prototype.hasOwnProperty.call(params.printLayoutItems[i], 'musicReference') && Array.isArray(params.printLayoutItems[i].musicReference)) {
          // New music tracks found

          // Update current song stack
          if (!firstNode && i === 0 && params.printLayoutItems[i].basePlaylist) {
            // skip
          } else {
            currentSongStack = params.printLayoutItems[i].musicReference;

            // Music stack could be empty, this == no music, check for this
            if (currentSongStack.length === 0) {
              // Check that node music array doesn't already have a null reference as it's last element
              if (params.printLayoutItems[i].music.length > 0 && params.printLayoutItems[i].music[params.printLayoutItems[i].music.length - 1] !== null && nextSongTime !== Infinity) {
                params.printLayoutItems[i].music.push(null);
                nextSongTime = Infinity;
              }
            } else {
              const song = currentSongStack.shift();

              // Add first song in stack to music array
              params.printLayoutItems[i].music.push(song);

              if (song.m_type === 'builtin') {
                this.songs.push({
                  builtin: song.m_builtin,
                  type: song.m_type,
                });
              } else {
                this.songs.push({
                  builtin: song.m_builtin,
                  album: song.m_album,
                  artist: song.m_artist,
                  isrc: song.m_isrc,
                  song: song.m_song,
                  type: song.m_type,
                });
              }

              // Track time for next song placement
              if (song.m_type === 'library') {
                nextSongTime = currentTime - duration + song.m_song_duration;
              } else {
                // Built in tracks loop forever
                nextSongTime = Infinity;
              }
            }
          }
        } else if (currentTime > nextSongTime) {
          while (currentTime > nextSongTime) {
            // Assign next song or null, depending on stack
            if (currentSongStack.length > 0) {
              const song = currentSongStack.shift();

              // Add first song in stack to music array
              params.printLayoutItems[i].music.push(song);

              if (song.m_type === 'builtin') {
                this.songs.push({
                  builtin: song.m_builtin,
                  type: song.m_type,
                });
              } else {
                this.songs.push({
                  builtin: song.m_builtin,
                  album: song.m_album,
                  artist: song.m_artist,
                  isrc: song.m_isrc,
                  song: song.m_song,
                  type: song.m_type,
                });
              }

              // Track time for next song placement
              if (song.m_type === 'library') {
                nextSongTime += song.m_song_duration;
              } else {
                // Built in tracks loop forever
                nextSongTime = Infinity;
              }
            } else {
              params.printLayoutItems[i].music.push(null);
              // No music loops forever
              nextSongTime = Infinity;
            }
          }
        } else if (firstNode) {
          params.printLayoutItems[i].music.push(null);
          // No music loops forever
          nextSongTime = Infinity;
        }

        // Unset first node flag, used for setting no music for the first node of a practice
        firstNode = false;

        // Loop checks
        if (Object.prototype.hasOwnProperty.call(params.printLayoutItems[i], 'loops')) {
          let decrementedDepth = false;
          let checking = true;
          let next = -2;

          while (checking) {
            // Manage current loop depth
            if (['all', 'start'].includes(params.printLayoutItems[i].loops[currentLoopDepth].loopMarker)) {
              if (currentLoopStartItem[currentLoopDepth] === -1) {
                // Store reference to current loop depth item and repeat countdown at current depth
                currentLoopStartItem[currentLoopDepth] = i;
                currentLoopRepeat[currentLoopDepth] = params.printLayoutItems[i].loops[currentLoopDepth].loopRepeatCount - 1;
              }
            }

            // Check for further depth at this node
            if (params.printLayoutItems[i].loops.length - 1 > currentLoopDepth && !decrementedDepth) {
              currentLoopDepth += 1;
            } else {
              checking = false;

              if (['all', 'end'].includes(params.printLayoutItems[i].loops[currentLoopDepth].loopMarker) && currentLoopRepeat[currentLoopDepth] >= 0) {
                // Decrement current loop repeat
                currentLoopRepeat[currentLoopDepth] -= 1;

                if (currentLoopRepeat[currentLoopDepth] >= 0) {
                  // Go back to start of loop, decrement by 1 to offset the loop increment
                  next = currentLoopStartItem[currentLoopDepth] - 1;
                } else {
                  currentLoopRepeat[currentLoopDepth] = -1;
                  currentLoopStartItem[currentLoopDepth] = -1;

                  if (currentLoopDepth > 0) {
                    currentLoopDepth -= 1;

                    // Check again with lower loop depth
                    checking = true;
                    decrementedDepth = true;
                  }
                }
              }
            }

            if (next > -2) {
              i = next;
            }
          }
        }
      }

      const isrc = [] as string[];

      const filteredSongs = this.songs.reduce((acc: Song[], current: Song) => {
        const x = acc.find(item => (item.type === 'builtin' && item.builtin === current.builtin) || (item.type === 'library' && item.isrc && item.isrc === current.isrc) || (item.type === 'library' && item.song === current.song));

        if (!x) {
          if (current.isrc) {
            isrc.push(current.isrc as string);
          }

          return acc.concat([current]);
        }

        return acc;
      }, []);

      if (isrc.length) {
        fetch('https://api.pocketyoga.com/services/music/previews', {
          method: 'POST',
          headers: { version: '5' },
          body: JSON.stringify({ isrc }),
        })
          .then((response) => {
            if (!response.ok) {
              throw response;
            }

            return response.json();
          })
          .then((json) => {
            this.songs = filteredSongs.map((song: Song): Song => {
              if (song.type === 'builtin' && song.builtin !== undefined) {
                // Assign builtin data
                song.album = '';
                song.artist = 'Built In';
                song.image = 'https://pocketyoga.com/images/builtin.jpg';
                song.song = builtin[song.builtin];
                // @ts-ignore
                song.preview = `https://pocketyoga.com/audio/${song.song.toLowerCase().replace(/\s/g, '')}.mp3`;

                return song;
              }

              for (let i = 0; i < json.length; i += 1) {
                if (song.isrc && json[i][song.isrc]) {
                  for (let j = 0; j < json[i][song.isrc].length; j += 1) {
                    if (json[i][song.isrc][j].attributes.albumName === song.album) {
                      song.image = json[i][song.isrc][j].attributes.artwork.url.replace('{w}', 72).replace('{h}', 72);
                      song.preview = json[i][song.isrc][j].attributes.previews[0].url;

                      return song;
                    }
                  }

                  song.image = json[i][song.isrc][0].attributes.artwork.url.replace('{w}', 72).replace('{h}', 72);
                  song.preview = json[i][song.isrc][0].attributes.previews[0].url;

                  return song;
                }
              }

              song.image = 'https://pocketyoga.com/images/defaultalbum.jpg';

              return song;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.songs = filteredSongs.map((song: Song): Song => {
          if (song.type === 'builtin' && song.builtin !== undefined) {
            // Assign builtin data
            song.album = '';
            song.artist = 'Built In';
            song.image = 'https://pocketyoga.com/images/builtin.jpg';
            song.song = builtin[song.builtin];
            // @ts-ignore
            song.preview = `https://pocketyoga.com/audio/${song.song.toLowerCase().replace(/\s/g, '')}.mp3`;

            return song;
          }

          song.image = 'https://pocketyoga.com/images/defaultalbum.jpg';

          return song;
        });
      }

      return params.printLayoutItems;
    },
    createSessionPrintLayoutWithDuration(
      node: DefinitionNode,
      params: PrintLayoutBuildParams,
      firstActionNode: number | null,
      lastTempoNode: DefinitionNode | null,
      lastMusicNode: DefinitionNode | null,
      index: number,
    ): StateUpdate {
      let loopEndIndex: number;
      let loopStartIndex: number;
      let newParams = params;
      let newFirstActionNode = firstActionNode;
      let newLastMusicNode = lastMusicNode;
      let newLastTempoNode = lastTempoNode;
      let repeatCount: number;
      let stateUpdate: StateUpdate;

      switch (node.type) {
        case 'section':
          newParams.printLayoutItems.push({
            section: true,
            label: node.s_title || null,
          });

          break;
        case 'custompose':
          if (params.firstOccurrence) {
            if (newFirstActionNode === null) {
              newFirstActionNode = index;
            }

            const printLayoutItem: PrintLayoutItem = {
              direction: node.p_pose_direction,
              section: false,
              displayName: node.cp_name,
              holdDuration: node.cp_duration !== 0 ? node.cp_duration : null,
              link: null,
              name: node.p_pose_name,
              side: node.p_pose_side,
            };

            printLayoutItem.image = 'custom_pose-tn80.png';

            if (lastTempoNode) {
              printLayoutItem.tempoTag = lastTempoNode.tempo;
              newLastTempoNode = null;
            }

            if (lastMusicNode) {
              printLayoutItem.musicReference = lastMusicNode.m_songs;
              printLayoutItem.basePlaylist = lastMusicNode.basePlaylist;
              newLastMusicNode = null;
            }

            newParams.printLayoutItems.push(printLayoutItem);
          }

          break;
        case 'loop':
          if (node.l_nodes.length === 0 || node.l_nodes === undefined) {
            break;
          }

          if (newFirstActionNode === null) {
            newFirstActionNode = index;
          }

          newParams.loopIterationDepth += 1;

          // Next node will be the first node in the loop
          loopStartIndex = params.printLayoutItems.length;
          repeatCount = node.l_count;

          for (let i = 0; i < node.l_nodes.length; i += 1) {
            stateUpdate = this.createSessionPrintLayoutWithDuration(
              node.l_nodes[i], newParams, newFirstActionNode, newLastTempoNode, newLastMusicNode, index,
            );

            ({
              lastTempoNode: newLastTempoNode,
              lastMusicNode: newLastMusicNode,
              params: newParams,
              firstActionNode: newFirstActionNode,
            } = stateUpdate);
          }

          loopEndIndex = params.printLayoutItems.length - 1;

          if (repeatCount > 1 && loopStartIndex < loopEndIndex) {
            if (loopStartIndex !== loopEndIndex) {
              if (newParams.printLayoutItems[loopStartIndex].loops === undefined) {
                newParams.printLayoutItems[loopStartIndex].loops = [];
              }

              newParams.printLayoutItems[loopStartIndex].loops[newParams.loopIterationDepth - 1] = {
                loopMarker: 'start',
                loopRepeatCount: repeatCount,
                loopSwitchSide: node.l_switch_side,
                loopSwitchDirection: node.l_switch_direction,
              };
            }

            for (let i = loopStartIndex + 1; i < loopEndIndex; i += 1) {
              if (newParams.printLayoutItems[i].loops === undefined) {
                newParams.printLayoutItems[i].loops = [];
              }

              newParams.printLayoutItems[i].loops[newParams.loopIterationDepth - 1] = {
                loopMarker: 'middle',
                loopRepeatCount: repeatCount,
                loopSwitchSide: node.l_switch_side,
                loopSwitchDirection: node.l_switch_direction,
              };
            }

            if (newParams.printLayoutItems[loopEndIndex].loops === undefined) {
              newParams.printLayoutItems[loopEndIndex].loops = [];
            }

            newParams.printLayoutItems[loopEndIndex].loops[newParams.loopIterationDepth - 1] = {
              loopMarker: 'end',
              loopRepeatCount: repeatCount,
              loopSwitchSide: node.l_switch_side,
              loopSwitchDirection: node.l_switch_direction,
            };
          } else {
            if (newParams.printLayoutItems[loopStartIndex].loops === undefined) {
              newParams.printLayoutItems[loopStartIndex].loops = [];
            }

            newParams.printLayoutItems[loopStartIndex].loops[newParams.loopIterationDepth - 1] = {
              loopMarker: 'all',
              loopRepeatCount: repeatCount,
              loopSwitchSide: node.l_switch_side,
              loopSwitchDirection: node.l_switch_direction,
            };
          }

          newParams.loopIterationDepth -= 1;

          break;
        case 'music':
          // Music playlists are base playlists for entire practices until the first action node is found
          // Action nodes: pose, custompose, loop
          // This keeps music from being reassigned in a loop when not yet intended
          if (newFirstActionNode === null) {
            node.basePlaylist = true;
          } else {
            node.basePlaylist = false;
          }

          newLastMusicNode = node;
          break;
        case 'pose':
          if (params.firstOccurrence) {
            if (newFirstActionNode === null) {
              newFirstActionNode = index;
            }

            const printLayoutItem: PrintLayoutItem = {
              direction: node.p_pose_direction,
              displayName: node.p_pose_name,
              section: false,
              holdDuration: node.p_duration !== 0 ? node.p_duration : null,
              link: node.p_pose_name,
              name: node.p_pose_name,
              side: node.p_pose_side,
            };

            printLayoutItem.displayName = this.poseNameEn(node.p_pose_name);
            printLayoutItem.image = this.poseImage(node.p_pose_name, node.p_pose_side, node.p_pose_direction);
            printLayoutItem.link = this.poseLink(node.p_pose_name);

            if (lastTempoNode) {
              printLayoutItem.tempo = Number(lastTempoNode.t_tempo).toFixed(1);
              newLastTempoNode = null;
            }

            if (lastMusicNode) {
              printLayoutItem.musicReference = lastMusicNode.m_songs;
              printLayoutItem.basePlaylist = lastMusicNode.basePlaylist;
              newLastMusicNode = null;
            }

            newParams.printLayoutItems.push(printLayoutItem);
          }

          break;
        case 'tempo':
          if (newParams.breathDuration !== node.t_tempo) {
            newParams.breathDuration = node.t_tempo;
            newLastTempoNode = node;
          }
          break;
        default:
          // What is this?
      }

      return {
        lastTempoNode: newLastTempoNode,
        lastMusicNode: newLastMusicNode,
        params: newParams,
        firstActionNode: newFirstActionNode,
      };
    },
    fetchData() {
      // Reassign this scope for callback usage
      const component = this;

      fetch(`https://api.pocketyoga.com/practices/${this.practiceId}`, {
        headers: { version: '5' },
      })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        })
        .then((json) => {
          component.practiceInfo = {
            cover_pose_name: json.cover_pose_name,
            cover_pose_side: json.cover_pose_side,
            created_at: json.created_at,
            description: json.description,
            difficulty: difficulty[json.difficulty],
            duration: json.duration,
            explicit_cover_pose: json.explicit_cover_pose,
            name: json.name,
            poses: json.poses,
            style: json.style,
            updated_at: json.updated_at,
            user: json.user,
          };

          if (json.practice_data[0].type !== 'tempo') {
            json.practice_data.unshift({
              type: 'tempo',
              t_tempo: 4,
            });
          }

          component.printLayout = component.createSessionLayoutRecursiveWithParams(json.practice_data);

          component.loaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    identifyPractice() {
      // Reassign this scope for callback usage
      const component = this;

      fetch(`https://api.pocketyoga.com/identify/practice/${this.$route.params.teacher}/${this.$route.params.practice}`, {
        headers: { version: '5' },
      })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        })
        .then((json) => {
          component.practiceId = json.id;
          component.fetchData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    playSong(song: Song, key: number) {
      if (!audio.src) {
        audio.addEventListener('ended', this.songEnded);
        audio.addEventListener('pause', this.songPaused);
        audio.addEventListener('play', this.songPlayed);
      }

      if (song.preview) {
        if (this.playing === key) {
          audio.pause();
          this.playing = undefined;
        } else {
          this.playing = key;
          audio.src = song.preview;
          audio.play();
        }
      }
    },
    poseImage(name: string, side: string, direction: string) {
      const sides: { [key: string]: string } = {
        left: '_L',
        right: '_R',
      };

      const directions: { [key: string]: string } = {
        back: '_L',
        forward: '_R',
      };

      const reverseDirection: { [key: string]: string } = {
        back: 'forward',
        forward: 'back',
      };

      const reverseSide: { [key: string]: string } = {
        left: 'right',
        right: 'left',
      };

      for (let i = 0; i < posesMap.length; i += 1) {
        if (posesMap[i].name === name) {
          let image: string = posesMap[i].name.replace(/\s+/g, '');

          if (posesMap[i].two_sided) {
            if (direction === 'back') {
              image += sides[reverseSide[side]];
            } else {
              image += sides[side];
            }
          }

          if (posesMap[i].sideways) {
            if (side === 'left') {
              image += directions[reverseDirection[direction]];
            } else {
              image += directions[direction];
            }
          }

          return `${image}-tn80.png`;
        }
      }

      // Default to custom pose if we didn't find the image
      return 'custom_pose.png';
    },
    poseLink(name: string) {
      for (let i = 0; i < posesMap.length; i += 1) {
        if (posesMap[i].name === name) {
          return `https://pocketyoga.com/pose/${posesMap[i].name.replace(/\s+/g, '')}`;
        }
      }
      return null;
    },
    poseNameEn(name: string) {
      for (let i = 0; i < posesMap.length; i += 1) {
        if (posesMap[i].name === name) {
          return posesMap[i].display_name;
        }
      }
      return name;
    },
    songEnded() {
      this.playing = undefined;
    },
    songPaused() {
      this.playing = undefined;
    },
    songPlayed() {
      for (let i = 0; i < this.songs.length; i += 1) {
        if (this.songs[i].preview === audio.src) {
          this.playing = i;
        }
      }
    },
  },
  filters: {
    convertTempo(tempo: string) {
      return parseFloat(tempo) * 2;
    },
    convertHoldDuration(duration: number) {
      if (duration > 0) {
        // Durations are marked by a positive p_duration
        return `${Math.floor(duration / 2) > 0 ? Math.floor(duration / 2) : ''}
          ${duration % 2 > 0 ? '½' : ''}`;
      }

      if (duration < 0) {
        // Holds are marked by a negative p_duration, normalized before use
        const total = Math.abs(duration);

        // Convert hold duration from seconds to ?m?s
        const minutes = Math.floor(total / 60);
        const seconds = total - minutes * 60;
        let hold = '';

        if (minutes > 0) {
          hold = `${minutes}m `;
        }

        if (seconds > 0) {
          hold += `${seconds}s`;
        }

        return hold;
      }

      return duration;
    },
    convertTotalDuration(duration: number) {
      return `${Math.ceil(duration / 60)} min`;
    },
    formatDate(value: string) {
      return moment(String(value)).format('MMM D, YYYY');
    },
    trim(value: string) {
      if (!value) {
        return '';
      }

      return value.trim();
    },
  },
});
